import { BannerProps } from './Banner.types';

function Banner({
  title,
  text,
  html,
  icon,
  backgroundColorClass,
  titleColorClass,
  textColorClass,
  iconColorClass,
  className
}: BannerProps) {
  const textClassNames = `w-full font-inter text-sm leading-5 tracking-normal ${textColorClass} m-0 text-left whitespace-pre-line [&_ul]:list-disc [&_ul]:ml-6 [&_li]:mb-0 [&_a]:underline`;
  const titleClassNames = `font-inter text-sm leading-6 tracking-normal ${titleColorClass} m-0 text-left font-semibold`;
  return (
    <div
      className={`flex items-start p-4 rounded-md gap-2 ${backgroundColorClass} ${className}`}
    >
      {icon && (
        <div
          className={`flex-shrink-0 flex items-center pt-1 justify-center w-5 h-5 ${iconColorClass}`}
        >
          {icon}
        </div>
      )}
      <div className="flex flex-col gap-2">
        {title && <h3 className={titleClassNames}>{title}</h3>}
        {html ? (
          <div
            className={textClassNames}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <div className={`[&_p]:mb-1 ${textClassNames}`}>{text}</div>
        )}
      </div>
    </div>
  );
}

export default Banner;
